/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Carousel_LabelInputs */

const da_forside_carousel_label = /** @type {(inputs: Forside_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`karrusel`)
};

/** @type {(inputs: Forside_Carousel_LabelInputs) => LocalizedString} */
const en_forside_carousel_label = da_forside_carousel_label;

/**

* @param {Forside_Carousel_LabelInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_carousel_label = /** @type {((inputs?: Forside_Carousel_LabelInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Carousel_LabelInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_carousel_label(inputs)
	return /** @type {LocalizedString} */ ("karrusel")
});